import React, { useState, useEffect } from "react";
import axios from "axios";
import CommonReportLayout from "./CommonReportLayout";
import { REACT_APP_API_URL } from "../../../../env";

const RequestReport = () => {
  const [data, setData] = useState([]);
  const [itemId, setItemId] = useState("");
  const [itemList, setItemList] = useState([]);

  useEffect(() => {
    loadItems();
  }, []);

  // ================= LOAD ITEMS =================
  const loadItems = async () => {
    try {
      const res = await axios.post(
        `${REACT_APP_API_URL}api/inventory-report/items`
      );

      setItemList(res.data || []);
    } catch (error) {
      console.log(error);
      setItemList([]);
    }
  };

  // ================= SHOW REPORT =================
  const fetchData = async () => {
    try {
      const payload = {
        itemId: Number(itemId || 0),
        reqId: 0
      };

      const res = await axios.post(
        `${REACT_APP_API_URL}api/inventory-report/request`,
        payload
      );

      setData(res.data || []);
    } catch (error) {
      console.log(error);
      setData([]);
    }
  };

  return (
    <>
      <div className="col-sm-12">
        <div className="d-flex align-items-center justify-content-between flex-wrap">
          <h3 className="fw-bold mb-0 px-lg-4 text-dark">
            Request Details Report
          </h3>
        </div>
      </div>

      <CommonReportLayout
        title="Request Report"
        onShow={fetchData}
        filters={
          <div className="col-md-4">
            <label>Select Request Item</label>

            <select
              className="form-control"
              value={itemId}
              onChange={(e) => setItemId(e.target.value)}
            >
              <option value="">-- All Items --</option>

              {itemList.map((item, i) => (
                <option key={i} value={item.ItemId}>
                  {item.ItemName}
                </option>
              ))}
            </select>
          </div>
        }
      >
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Sl#</th>
              <th>Category</th>
              <th>SubCategory</th>
              <th>Item</th>
              <th>Qty</th>
            </tr>
          </thead>

          <tbody>
            {data.length > 0 ? (
              data.map((item, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{item.ItemCategoryName}</td>
                  <td>{item.ItemSubCategoryName}</td>
                  <td>{item.ItemName}</td>
                  <td>{item.NoOfItems}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </CommonReportLayout>
    </>
  );
};

export default RequestReport;